import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { DishServices } from '../../dish/services';
import { Uploads } from '../../services/uploads';
import { ConfigurationServices } from '../../configuration/services';
import { OrdersCoServices } from '../../orders/services';
import { TPVServices } from '../../tpv/services';
import { TakeawayServices } from '../../takeaway/services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationVariationCreateListPage } from '../../configuration/configuration-variations/configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list';



@Component({
  selector: 'page-variations-dish-selector',
  templateUrl: 'variations-dish-selector.html',
})
export class VariationsDishSelectorPage {
  name: string;
  price_selected: any = 0;
  price: any;
  price12: any;
  priceTapa: any;
  type: any;
  uid: any;
  units: number = 1;
  type_selected: any = "price";
  section: any;
  dish: any;
  sender: any;
  tags: any;

  poco_hecho: string;
  al_punto: string;
  muy_hecho: string;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public dishServices: DishServices,
    public uploadServices: Uploads,
    public configurationServices: ConfigurationServices,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public translate: TranslateService) {

    this.name = this.navParams.get('name');
    this.price = this.navParams.get('price');
    this.price12 = this.navParams.get('price12');
    this.priceTapa = this.navParams.get('priceTapa');
    this.type = this.navParams.get('type');
    this.uid = this.navParams.get('uid');
    this.section = this.navParams.get('section');
    this.sender = this.navParams.get('sender');//on s'envia la crida de variacions (comandero - tpv- takeaway)
    this.tags = this.navParams.get('tags');
    //check prices nan/undefined
    if (Number.isNaN(this.price12) || this.price12 == undefined) {
      this.price12 = 0;
    }
    if (Number.isNaN(this.priceTapa) || this.priceTapa == undefined) {
      this.priceTapa = 0;
    }
    //
    this.poco_hecho = this.translate.instant('variations-selector-poco-hecho');
    this.al_punto = this.translate.instant('variations-selector-al-punto');
    this.muy_hecho = this.translate.instant('variations-selector-muy-hecho');

    this.dishServices.image_url_dish_view = null;
    this.configurationServices.getVariations(this.globals.restaurant_uid);
    this.getFoodCost();
  }

  async getFoodCost() {
    if (this.type == 'dish') {
      this.dish = await this.dishServices.getDish(this.uid);
      if (this.dish.variations_favourite == undefined) {
        this.dish.variations_favourite = [];
      }
      this.getImageUrl(this.dish.image);
    }
  }

  onChange(event) {
    this.units = event.target.value;
  }

  add() {
    this.units++;
  }

  rest() {
    if (this.units > 1) {
      this.units--;
    }

  }

  checkState(type) {
    if (this.type_selected == type) {
      return true
    } else {
      return false
    }
  }

  select(type) {
    if (this.globals.checkLimitsByLicense('dishes', '3prices')) {
      this.type_selected = type;
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  deleteVariation(index) {
    if (this.sender == 'comandero') {
      this.ordersCoServices.variations_tmp.splice(index, 1);
    } else if (this.sender == 'tpv') {
      this.tpvServices.variations_tmp.splice(index, 1);
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.variations_tmp.splice(index, 1);
    }

  }

  //insertemamos variacion al array temporal
  insertVariation(name, price, state, type, uid) {

    var _array = {
      name: name,
      price: price,
      state: state,
      type: type,
      uid: uid,
    };

    if (this.sender == 'comandero') {
      this.ordersCoServices.variations_tmp.push(_array);
    } else if (this.sender == 'tpv') {
      this.tpvServices.variations_tmp.push(_array);
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.variations_tmp.push(_array);
    }
  }

  insertToTicket() {
    if (this.type_selected == 'price') {
      this.price_selected = this.price;
    } else if (this.type_selected == 'price_half') {
      this.price_selected = this.price12;
      this.name = this.name + " <b> M.</b>";
    } else if (this.type_selected == 'price_tapa') {
      this.price_selected = this.priceTapa;
      this.name = this.name + " <b> P.</b>";
    }

    if (this.sender == 'comandero') {
      this.ordersCoServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, this.section, { tags: this.tags });
    } else if (this.sender == 'tpv') {
      this.tpvServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, { tags: this.tags });
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, this.section, { tags: this.tags });
    }


    this.navCtrl.pop();
  }

  getImageUrl(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    this.dishServices.image_url_dish_view = null;
    if (image_ref) {
      const ref = this.uploadServices.storage.ref(image_ref);
      this.dishServices.image_url_dish_view = ref.getDownloadURL();
    }

  }

  back() {
    this.navCtrl.pop();
  }

  setStyle(img) {

    let styles = {
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'height': '300px',
      'background-image': 'url(' + img + ')',
    };
    return styles;
  }

  createVariation() {
    if (this.globals.checkLimitsByLicense('tpv', 'variations')) {
      this.navCtrl.push(ConfigurationVariationCreateListPage, {
        type: 'all'
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/variations/variations-dish-selector/variations-dish-selector.ts